<template>
  <base-material-card :icon="resource.icon" :title="title">
    <template v-slot:subtitle>
      <info-text :resource="resource" crud-type="list" />
    </template>
    <va-list :filters="filters" :sort-by="['code']" disable-export>
      <template v-slot:actions="slotProps">
        <export-poll-button :resource="resource.name" text :options="slotProps.listState.options" :filter="slotProps.currentFilter" />
      </template>
      <va-data-table :fields="fields"></va-data-table>
    </va-list>
  </base-material-card>
</template>

<script>
import i18n from "@/i18n";
import { AddressTypes } from "@/resources/company-addresses/Helper";
import InfoText from "@/components/helper/InfoText";
import ExportPollButton from "../../components/export/ExportPollButton";

export default {
  components: { ExportPollButton, InfoText },
  props: ["resource", "title"],
  data() {
    return {
      fields: [
        {
          label: i18n.t("integrations.fields.code"),
          source: "code",
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.company"),
          source: "company_data",
          type: "reference-array",
          sortable: true,
          attributes: {
            reference: "companies",
            action: this.$admin.can(["ROLE_ADMIN"]) ? "edit" : null
          }
        },
        {
          label: i18n.t("integrations.fields.organization"),
          source: "organization",
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.department"),
          source: "department",
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.street"),
          source: "street",
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.postal_code"),
          source: "postal_code",
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.city"),
          source: "city",
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.country"),
          source: "country"
        },
        {
          label: i18n.t("integrations.fields.address_types"),
          source: "address_types",
          type: "array",
          attributes: {
            itemText: item => {
              return i18n.t("integrations.address.type." + item.toLowerCase());
            }
          }
        }
      ],
      filters: [
        {
          label: i18n.t("integrations.fields.code"),
          source: "code",
          alwaysOn: true
        },
        {
          label: i18n.t("integrations.fields.company"),
          source: "tenant",
          type: "autocomplete",
          alwaysOn: true,
          resettable: true,
          attributes: {
            reference: "companies",
            searchQuery: "q",
            itemText: record => record.name + " (" + record.group + ")",
            sortBy: ["name"]
          }
        },
        {
          label: i18n.t("integrations.fields.address_type"),
          source: "address_types",
          type: "select",
          attributes: {
            multiple: true,
            choices: AddressTypes,
            itemText: "name",
            itemValue: "id"
          }
        },
        {
          label: i18n.t("integrations.fields.organization"),
          source: "organization"
        },
        {
          label: i18n.t("integrations.fields.department"),
          source: "department"
        },
        {
          label: i18n.t("integrations.fields.postal_code"),
          source: "postal_code"
        },
        {
          label: i18n.t("integrations.fields.city"),
          source: "city"
        },
        {
          label: i18n.t("integrations.fields.country"),
          source: "country",
          type: "autocomplete",
          resettable: true,
          attributes: {
            reference: "countries",
            searchQuery: "q"
          }
        }
      ]
    };
  }
};
</script>
